import EvalSelectDepartment from './src/main';

/* istanbul ignore next */
EvalSelectDepartment.install = function(Vue) {
  Vue.component(EvalSelectDepartment.name, EvalSelectDepartment);
};

export default EvalSelectDepartment;
